import { Cnes } from 'api/Cnes'
import { FichaSinan } from 'api/FichaSinan'
import { Transmissao } from 'api/Transmissao'

import { AcompanhamentoSaudeRelatorio } from './AcompanhamentoSaudeRelatorio'
import { AtencaoDomiciliar } from './AtencaoDomiciliar'
import { ImpressaoAtendimentoIndividual } from './ImpressaoAtendimentoIndividual'
import { ImpressaoMedicamentos } from './ImpressaoMedicamentos'

export default {
  cnes: new Cnes(),
  transmissao: new Transmissao(),
  fichaSinan: new FichaSinan(),
  acompanhamentoSaude: new AcompanhamentoSaudeRelatorio(),
  atencaoDomiciliar: new AtencaoDomiciliar(),
  atendimentoIndividual: new ImpressaoAtendimentoIndividual(),
  prescricaoMedicamento: new ImpressaoMedicamentos(),
}
